module.exports = __webpack_public_path__ + "2c0481a4c4965abf788035b851e460aa.svg";